import React, { useState } from "react";
import {
  Switch,
  Form,
  Flex,
  Card,
  Button,
  Col,
  Row,
  Modal,
  message,
  Spin,
} from "antd";
import { Input, Select } from "antd";
import { InfoCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { Category } from "../../types/category";
import { getAllCategories } from "../../network/category";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { listParentwithServices } from "../../network/service";
import { service } from "../../types/service";

import DeleteSVG from "../../assets/common/DeleteSVG";
import { queryKeys } from "../../services/react-query/queryKeys";
import {
  addPackage,
  getPackagesCategories,
  updatePackage,
} from "../../network/package";
import { PricingTypeEnum } from "../../enum/packagePriceType";
import IconSVG from "../../assets/teamMember/IconSVG";
import VectorSVG from "../../assets/common/VectorSVG";
import GenderSwitch from "../common/GenderSwitch";
import { Radio } from "antd";
import { FormattedMessage, useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { packageDetailsType } from "../../types/package";
import { getTeamMembersLocation } from "../../network/teamMember";
import AddTeamMember from "../teamMember/creatTeamMember/AddTeamMember";
import { checkStringInLanguage } from "../../utils/utils";
import FormItem from "antd/es/form/FormItem";

interface AddPackageFormProps {
  visible: boolean;
  onClose: () => void;
  editPackageData?: packageDetailsType;
  refetch?: () => void;
}

const AddAndEditPackageForm: React.FC<AddPackageFormProps> = ({
  visible,
  onClose,
  editPackageData,
  refetch,
}) => {
  const [active, setActive] = useState(
    editPackageData ? editPackageData?.available_for : "both"
  );
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const queryClient = useQueryClient();
  const { currentLang } = useSelector(
    (state: { user: { currentLang: "en" | "ar" } }) => state.user
  );

  const [selectedServices, setSelectedServices] = useState<
    Array<{
      id: number;
      pricing_option_id: number;

      duration: string;
      price: string;
      price_type: string;
      name: string;
      currency: string;
      service_id: number;
      service?: any;
    }>
  >(
    (editPackageData &&
      editPackageData?.pricing_option?.map((item) => ({
        ...item,
        name: item?.service?.name[currentLang],
        pricing_option_id: item?.id,
      }))) ||
      []
  );
  const [form] = Form.useForm();
  const { locationId } = useSelector(
    (state: { calendar: { locationId: number } }) => state?.calendar
  );
  const {
    data: listTeamMember,
    isFetching,
    isLoading: isTeamMemberLoading,
  } = useQuery([queryKeys?.listTeamMember, locationId], () =>
    getTeamMembersLocation(locationId)
  );
  const { data: listCategories, isLoading: isCategoryLoading } = useQuery(
    [queryKeys.listCategories],
    () =>
      getAllCategories({
        "location_ids[0]": locationId,
      })
  );

  const { data: listServices, isFetching: isServiceLoading } = useQuery(
    [queryKeys.listServices, selectedCategoryId],
    () =>
      listParentwithServices({
        category_id: selectedCategoryId,
        location_id: locationId,
      }),
    {
      enabled: !!selectedCategoryId,
    }
  );

  const { mutate: onAddPackages, isLoading } = useMutation(
    (data) => addPackage(locationId, data),
    {
      onSuccess: (res: any) => {
        console.log(res, "res?.response?.status");
        console.log(res?.response, "res?.response?.status");
        if (res?.response?.status === 422 || res?.response?.status === 500) {
          message.error(res?.response?.data?.message);
        } else {
          message.success(intl.formatMessage({ id: "packageAddedSuccess" }));
          queryClient.invalidateQueries([queryKeys.listPackages]);
          onClose();
        }
      },
      onError: (error) => {
        message.error(intl.formatMessage({ id: "tryAgain" }));
      },
      onSettled: () => {
        queryClient.invalidateQueries([queryKeys.listCategories]);
      },
    }
  );

  const { mutate: onUpdatePackages, isLoading: updateLoading } = useMutation(
    (data) => updatePackage(locationId, editPackageData?.id, data),
    {
      onSuccess: (res) => {
        onClose();
        message.success(intl.formatMessage({ id: "packageUpdatedSuccess" }));
        queryClient.invalidateQueries([queryKeys.listPackages]);
        if (refetch) {
          refetch();
        }
      },
      onError: (error) => {
        console.log(" Package error:", error);
        message.error("حاول مرة اخرى");
      },
    }
  );
  const onFinish = async (values: any) => {
    values.services = selectedServices;
    values.enable_online_booking = true;
    if (Number(values.total_time) <= 0) {
      delete values.total_time;
    }
    if (editPackageData) {
      onUpdatePackages(values);
      return;
    } else {
      onAddPackages(values);
    }
  };
  const changeGender = (e: any) => {
    setActive(e.target.value);
  };
  const handleRemoveService = (serviceId: any) => {
    const newServices = selectedServices?.filter(
      (item) => item.id !== serviceId
    );
    setSelectedServices(newServices);
  };

  let non_discounted_price = selectedServices?.reduce(
    (acc: any, item: any) => acc + parseFloat(item?.price),
    0
  );

  let retail_price = 0;

  const priceType = Form.useWatch("price_type", form);
  const retailPrice = Form.useWatch("retail_price", form);
  const percentageDiscount = Form.useWatch("percentage_discount", form);

  switch (priceType) {
    case PricingTypeEnum.Free:
      retail_price = 0;
      break;
    case PricingTypeEnum.ServicePrice:
      retail_price = non_discounted_price;
      break;
    case PricingTypeEnum.CustomPrice:
      retail_price = retailPrice;
      break;
    case PricingTypeEnum.PercentageDiscount:
      retail_price =
        non_discounted_price -
        non_discounted_price * (percentageDiscount / 100);
      break;
    default:
      break;
  }
  const intl = useIntl();

  const { data: listPackagesCategories, isLoading: isTypesLoading } = useQuery(
    [queryKeys.listPackagesCategories],
    () => getPackagesCategories(),
    {
      select: (res) => res?.data,
    }
  );

  const packagesCategoriesOptions = Array.isArray(listPackagesCategories)
    ? listPackagesCategories?.map((category) => ({
        label: category?.name,
        value: category?.id,
        key: category?.id,
      }))
    : [];

  const PricingTypes: { value: string; label: string }[] = [
    {
      value: PricingTypeEnum.Free,
      label: intl.formatMessage({ id: "intl.form.free" }),
    },
    {
      value: PricingTypeEnum.CustomPrice,
      label: intl.formatMessage({ id: "intl.form.customPrice" }),
    },
    {
      value: PricingTypeEnum.PercentageDiscount,
      label: intl.formatMessage({ id: "intl.form.percentageDiscount" }),
    },
    {
      value: PricingTypeEnum.ServicePrice,
      label: intl.formatMessage({ id: "intl.form.servicePrice" }),
    },
  ];
  const closeModal = () => {
    setIsModalVisible(false);
  };

  return (
    <Modal
      centered
      open={visible}
      onCancel={onClose}
      okButtonProps={{ disabled: true }}
      cancelButtonProps={{ disabled: true }}
      footer={[]}
      width={1300}
    >
      {editPackageData && (isTypesLoading || isTeamMemberLoading) ? (
        <div className="flex justify-center items-center h-full">
          <Spin size="large" />
        </div>
      ) : (
        <div>
          {isModalVisible && (
            <AddTeamMember
              visible={true}
              onClose={closeModal}
              showMinForm
              config={{ locationId: locationId }}
            />
          )}
          <Card className="mx-8">
            <div className="text-color-primary text-2xl font-semibold leading-7 text-center">
              <FormattedMessage
                id={
                  editPackageData ? "edit_package_title" : "add_package_title"
                }
              />
            </div>

            <div className="my-4 text-color-gray text-base font-normal leading-7 text-center">
              <FormattedMessage id="add_package_description" />
            </div>

            <Form
              layout="vertical"
              onFinish={onFinish}
              initialValues={
                editPackageData
                  ? {
                      ...editPackageData,
                      package_category_id: editPackageData?.package_category_id,
                      available_for: active,
                      services: [{}],
                      team_member_ids: editPackageData?.team_members?.map(
                        (member: { id: number }) => member?.id
                      ),
                    }
                  : {
                      is_available: true,
                      available_for: active,
                      enable_online_booking: false,
                      auto_add_to_new_sale: false,
                      services: [{}],
                    }
              }
              form={form}
            >
              <Row gutter={{ xs: 8, sm: 16, md: 8, lg: 14 }}>
                <Col
                  className="gutter-row"
                  xl={8}
                  lg={8}
                  xs={24}
                  sm={24}
                  span={11}
                >
                  <Form.Item
                    name={["name", "ar"]}
                    label={
                      intl.formatMessage({ id: "package_name_label" }) +
                      " " +
                      intl.formatMessage({ id: "inArabic" })
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: (
                          <FormattedMessage id="package_name_required_message" />
                        ),
                      },
                      {
                        type: "string",
                        min: 2,
                        message: (
                          <FormattedMessage id="package_name_min_length_message" />
                        ),
                      },
                      {
                        validator: (_, value) => {
                          if (value) {
                            if (checkStringInLanguage(value, "ar")) {
                              return Promise.resolve();
                            } else {
                              return Promise.reject(
                                new Error(
                                  intl.formatMessage({
                                    id: "service_name_arabic_error",
                                  })
                                )
                              );
                            }
                          }
                        },
                      },
                    ]}
                    initialValue={editPackageData?.name}
                  >
                    <Input
                      placeholder={intl.formatMessage({
                        id: "enter_package_name_placeholder",
                      })}
                    />
                  </Form.Item>
                </Col>
                <Col
                  className="gutter-row"
                  xl={8}
                  lg={8}
                  xs={24}
                  sm={24}
                  span={11}
                >
                  <Form.Item
                    name={["name", "en"]}
                    label={
                      intl.formatMessage({ id: "package_name_label" }) +
                      " " +
                      intl.formatMessage({ id: "inEnglish" })
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: (
                          <FormattedMessage id="package_name_required_message" />
                        ),
                      },
                      {
                        type: "string",
                        min: 2,
                        message: (
                          <FormattedMessage id="package_name_min_length_message" />
                        ),
                      },
                      {
                        validator: (_, value) => {
                          if (value) {
                            if (checkStringInLanguage(value, "en")) {
                              return Promise.resolve();
                            } else {
                              return Promise.reject(
                                new Error(
                                  intl.formatMessage({
                                    id: "service_name_english_error",
                                  })
                                )
                              );
                            }
                          }
                        },
                      },
                    ]}
                    initialValue={editPackageData?.name}
                  >
                    <Input
                      placeholder={intl.formatMessage({
                        id: "enter_package_name_placeholder",
                      })}
                    />
                  </Form.Item>
                </Col>
                <Col
                  className="gutter-row"
                  xl={8}
                  lg={8}
                  xs={24}
                  sm={24}
                  span={11}
                >
                  <Form.Item
                    name="package_category_id"
                    label={intl.formatMessage({ id: "packageType" })}
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: intl.formatMessage({
                          id: "packageTypeRequired",
                        }),
                      },
                    ]}
                  >
                    <Select
                      loading={isTypesLoading}
                      placeholder={intl.formatMessage({
                        id: "selectPackageType",
                      })}
                      options={packagesCategoriesOptions}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row
                gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                justify={"space-between"}
                className="items-baseline"
              >
                <Col className="gutter-row">
                  <label className="text-right font-normal mt-3 w-full text-lg ">
                    <FormattedMessage id="available_for" />
                  </label>
                </Col>
                <Form.Item
                  name="available_for"
                  required={false}
                  initialValue={editPackageData?.name}
                  rules={[
                    {
                      required: true,
                      message: intl.formatMessage({
                        id: "select_gender_message",
                      }),
                    },
                  ]}
                >
                  <Col className="gutter-row mx-5">
                    <Radio.Group onChange={changeGender}>
                      <Row
                        gutter={{ xs: 8, sm: 0, md: 24, lg: 14 }}
                        justify={"space-between"}
                      >
                        <Col className="gutter-row">
                          <GenderSwitch
                            active={"woman" === active}
                            gender="woman"
                            string={<FormattedMessage id="women_only" />}
                          />
                        </Col>
                        <Col className="gutter-row">
                          <GenderSwitch
                            active={"man" === active}
                            gender="man"
                            string={<FormattedMessage id="men_only" />}
                          />
                        </Col>
                        <Col className="gutter-row">
                          <GenderSwitch
                            active={"both" === active}
                            gender="both"
                            string={<FormattedMessage id="both_genders" />}
                          />
                        </Col>
                      </Row>
                    </Radio.Group>
                  </Col>
                </Form.Item>
              </Row>

              <Row
                gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                justify={"space-between"}
                className="items-baseline"
              >
                <Col className="gutter-row" sm={24} md={12}>
                  <label className="text-right font-normal mt-3 w-full text-lg ">
                    <FormattedMessage id="selectTeamMembers" />
                  </label>
                </Col>
                <Col className="gutter-row" sm={24} md={12}>
                  <Form.Item
                    name="team_member_ids"
                    required={false}
                    // initialValue={editPackageData?.name}
                    rules={[
                      {
                        required: true,
                        // message: intl.formatMessage({
                        //   id: "select_gender_message",
                        // }),
                      },
                    ]}
                  >
                    <Select
                      loading={isTeamMemberLoading}
                      mode="tags"
                      style={{ width: "100%" }}
                      options={listTeamMember?.data?.map((item: Category) => ({
                        value: item?.id,
                        label: item?.name,
                      }))}
                      maxTagCount="responsive"
                      placeholder={intl.formatMessage({
                        id: "select_team_members",
                      })}
                      dropdownRender={(menu) => (
                        <>
                          {menu}
                          <Button
                            onClick={() => setIsModalVisible(true)}
                            icon={<PlusOutlined />}
                            type="primary"
                            className="w-full btn-primary-light border-0"
                            style={{ justifyContent: "flex-start" }}
                            size="small"
                          >
                            {intl.formatMessage({
                              id: "add_team_member",
                            })}{" "}
                          </Button>
                        </>
                      )}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row
                gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                justify={"space-between"}
              >
                <Col className="gutter-row">
                  <label className="text-right font-normal mt-3 w-full text-lg ">
                    {intl.formatMessage({ id: "auto_add_to_new_sale_label" })}
                  </label>
                </Col>
                <Col className="gutter-row">
                  <Form.Item
                    name="auto_add_to_new_sale"
                    valuePropName="checked"
                    rules={[
                      {
                        required: true,
                        message: intl.formatMessage({
                          id: "new_sale_required_message",
                        }),
                      },
                    ]}
                  >
                    <Switch />
                  </Form.Item>
                </Col>
              </Row>

              <Form.List name="services">
                {(fields, { add, remove }) => (
                  <>
                    <Form.Item className="p-2 rounded bg-color-light-gr w-full text-color-primary">
                      <Row className="mb-4">
                        <Col
                          className="gutter-row"
                          xl={24}
                          lg={8}
                          xs={24}
                          sm={24}
                          span={11}
                        >
                          <label className="text-color-primary">
                            {intl.formatMessage({
                              id: "servicesLabel",
                            })}
                          </label>
                        </Col>
                      </Row>

                      {fields.map(({ key, name, ...restField }, index) => (
                        <div
                          key={key}
                          className="grid grid-cols-1 md:grid-cols-2 gap-2"
                        >
                          <div className="">
                            <Form.Item
                              {...restField}
                              required={false}
                              label={intl.formatMessage({
                                id: "service_category_label",
                              })}
                              rules={[
                                {
                                  required: true,
                                  message: intl.formatMessage({
                                    id: "service_category_required_message",
                                  }),
                                },
                              ]}
                            >
                              <Select
                                loading={isCategoryLoading}
                                placeholder={intl.formatMessage({
                                  id: "select_service_category_placeholder",
                                })}
                                className="w-full my-input"
                                options={listCategories?.data?.map(
                                  (item: Category) => ({
                                    value: item?.id,
                                    label: item?.name,
                                  })
                                )}
                                onChange={(value) =>
                                  setSelectedCategoryId(value)
                                }
                              />
                            </Form.Item>
                          </div>
                          <div className="grid grid-cols-6 items-center w-full gap-2">
                            <Form.Item
                              {...restField}
                              required={false}
                              name={["services"]}
                              label={intl.formatMessage({
                                id: "service_label",
                              })}
                              className="w-full col-span-5"
                              // rules={[{ required: true, message: "اختر الخدمة " }]}
                            >
                              <Select
                                loading={isServiceLoading}
                                disabled={!!isServiceLoading}
                                placeholder={intl.formatMessage({
                                  id: "select_service_placeholder",
                                })}
                                className="!w-full my-input"
                                options={
                                  listServices?.data
                                    ? listServices?.data?.flatMap(
                                        (service: any) => {
                                          return service.pricing_options.map(
                                            (pricingOption: any) => {
                                              const selectedBefore =
                                                selectedServices?.find(
                                                  (item) =>
                                                    item.service_id ===
                                                      service.id &&
                                                    item.id === pricingOption.id
                                                );
                                              if (selectedBefore) {
                                                return {
                                                  value: `${service.id}-${pricingOption.id}`,
                                                  label: `${service.name} - ${
                                                    pricingOption.price
                                                  } ${intl.formatMessage({
                                                    id: "saudi_riyal",
                                                  })} `,
                                                  disabled: true,
                                                };
                                              }
                                              return {
                                                value: `${service.id}-${pricingOption.id}`,
                                                label: `${service.name} - ${
                                                  pricingOption.price
                                                } ${intl.formatMessage({
                                                  id: "saudi_riyal",
                                                })}`,
                                              };
                                            }
                                          );
                                        }
                                      )
                                    : []
                                }
                              />
                            </Form.Item>
                            <Button
                              className="col-span-1 border-none bg-transparent shadow-none outline-none"
                              onClick={() => {
                                const selectedServiceId = form.getFieldValue([
                                  "services",
                                ])["services"];
                                if (typeof selectedServiceId !== "string") {
                                  return false;
                                }

                                const [serviceId, pricingOptionId] =
                                  selectedServiceId.split("-");
                                const service: service | undefined =
                                  listServices?.data?.find(
                                    (service: service) =>
                                      service?.id === parseInt(serviceId)
                                  );
                                if (!service) return;
                                const pricingOption =
                                  service?.pricing_options?.find(
                                    (pricingOption) =>
                                      pricingOption?.id ===
                                      parseInt(pricingOptionId)
                                  );
                                if (!pricingOption) return;
                                const selectedOptionBefore =
                                  selectedServices.find(
                                    (item) =>
                                      item.service_id === parseInt(serviceId) &&
                                      item.id === parseInt(pricingOptionId)
                                  );
                                if (selectedOptionBefore) return false;
                                setSelectedServices([
                                  ...selectedServices,
                                  {
                                    service_id: parseInt(serviceId),
                                    id: parseInt(pricingOptionId),
                                    price: pricingOption?.price,
                                    name: service?.name,
                                    duration: pricingOption?.duration,
                                    currency: pricingOption?.currency || "SAR",
                                    price_type: pricingOption?.price_type,
                                    service: service,
                                    pricing_option_id: pricingOption?.id,
                                  },
                                ]);
                                form.resetFields(["services", index]);
                              }}
                              block
                              icon={
                                <PlusOutlined className="bg-[#00086D] text-white p-1 rounded-md" />
                              }
                            ></Button>
                          </div>
                        </div>
                      ))}
                      <div>
                        {selectedServices?.map((pricingOption) => (
                          <div
                            key={pricingOption?.id}
                            className="flex  px-2 gap-2 my-1 bg-white p-1 justify-between item-center rounded"
                          >
                            <div className="grid grid-cols-3 gap-2 items-center w-full">
                              <div className="flex gap-2 items-center ">
                                <span className="translate-y-0.5">
                                  <IconSVG />
                                </span>
                                <span>{pricingOption?.name}</span>
                              </div>
                              <div className="flex gap-1 items-center ">
                                <VectorSVG />
                                <span>{pricingOption?.duration}</span>
                                <small className="text-xs self-center mt-2">
                                  <FormattedMessage
                                    id="minutes"
                                    defaultMessage="minutes"
                                  />
                                </small>
                              </div>

                              <div className="flex gap-1 items-center ">
                                <VectorSVG />
                                <span>{pricingOption?.price}</span>
                                <small className="text-xs self-center mt-2">
                                  <FormattedMessage
                                    id="saudi_riyal"
                                    defaultMessage="Saudi Riyal"
                                  />
                                </small>
                              </div>
                            </div>
                            <Button
                              type="text"
                              htmlType="button"
                              onClick={() =>
                                handleRemoveService(pricingOption?.id)
                              }
                              className="w-fit ms-auto"
                            >
                              <DeleteSVG />
                            </Button>
                          </div>
                        ))}
                      </div>
                    </Form.Item>
                  </>
                )}
              </Form.List>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4  ">
                <div className=" bg-[#EEF0FF] w-full  grid grid-cols-1 lg:grid-cols-2 gap-4  px-4 pt-5  rounded ">
                  <FormItem
                    name="expected_time"
                    label={intl.formatMessage({ id: "expected_time" })}
                  >
                    <div>
                      <Input
                        type="number"
                        disabled
                        id="expected_time"
                        value={selectedServices?.reduce(
                          (acc, cur) => acc + Number(cur.duration),
                          0
                        )}
                        suffix={intl.formatMessage({ id: "minutes" })}
                      />
                    </div>
                  </FormItem>

                  <Form.Item
                    name="total_time"
                    label={
                      <p>
                        {intl.formatMessage({ id: "actual_time" })}{" "}
                        <small className="text-xs ">
                          {/* {"( "}
                          {intl.formatMessage({ id: "optional" })}
                          {" )"} */}
                        </small>
                      </p>
                    }
                    required={false}
                    className=""
                    rules={[
                      {
                        validator: (_, value) => {
                          const numericValue = parseFloat(value);
                          if (
                            (value && isNaN(numericValue)) ||
                            numericValue < 1
                          ) {
                            return Promise.reject(
                              intl.formatMessage({
                                id: "validNumberGreaterThanZero",
                              })
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Input
                      type="number"
                      min={1}
                      placeholder={intl.formatMessage({
                        id: "enter_package_duration",
                      })}
                      suffix={intl.formatMessage({ id: "minutes" })}
                    />
                  </Form.Item>
                </div>

                <div className="p-6 rounded bg-[#EEF0FF] w-full ">
                  <div className="text-center py-2">
                    <span>
                      <FormattedMessage
                        id="basic_package_price"
                        defaultMessage="Basic Package Price"
                      />
                      :
                    </span>
                    <span className="p-1 items-center text-center ">
                      <span>{non_discounted_price}</span>
                      <small className="text-xs self-center mt-2 mx-1">
                        <FormattedMessage
                          id="saudi_riyal"
                          defaultMessage="ريال"
                        />
                      </small>
                    </span>
                  </div>

                  <div className="text-[#A3A3B2] text-xs text-center py-2">
                    <InfoCircleOutlined />{" "}
                    <FormattedMessage id="automatic_package_price_calculation" />
                  </div>
                </div>
              </div>

              <div className="space-y-2 p-2 gap-2 rounded bg-color-light-gr w-full">
                <div>
                  <label htmlFor="" className="text-color-primary">
                    <FormattedMessage
                      id="pricing_title"
                      defaultMessage="تسعير البيع"
                    />
                  </label>
                </div>
                <div className="grid grid-cols-1  sm:grid-cols-2 lg:grid-cols-3  gap-2">
                  <div className="">
                    <Form.Item
                      name="price_type"
                      label={
                        <FormattedMessage
                          id="pricing_type_label"
                          defaultMessage="نوع التسعير"
                        />
                      }
                      initialValue={PricingTypeEnum.ServicePrice}
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: (
                            <FormattedMessage
                              id="pricing_type_required_message"
                              defaultMessage=" نوع التسعير مطلوب"
                            />
                          ),
                        },
                      ]}
                    >
                      <Select
                        placeholder={
                          <FormattedMessage
                            id="select_pricing_type_placeholder"
                            defaultMessage="اختر نوع التسعير"
                          />
                        }
                        id="input-with-icon-adornment"
                        options={PricingTypes.map((item) => ({
                          value: item.value,
                          label: item.label,
                        }))}
                      />
                    </Form.Item>
                  </div>
                  <div className="">
                    <Form.Item
                      noStyle
                      shouldUpdate={(prevValues, currentValues) =>
                        prevValues["price_type"] !== currentValues["price_type"]
                      }
                    >
                      {({ getFieldValue }) => {
                        const selectedPriceType = getFieldValue("price_type");

                        if (
                          selectedPriceType ===
                          PricingTypeEnum.PercentageDiscount
                        ) {
                          return (
                            <Form.Item
                              name="percentage_discount"
                              label={intl.formatMessage({
                                id: "percentage_label",
                              })}
                              required={false}
                              rules={[
                                // {
                                //   required: true,
                                //   message: intl.formatMessage({
                                //     id: "percentage_required_message",
                                //   }),
                                // },
                                // {
                                //   type: "string",
                                //   min: 0,
                                //   max: 100,
                                //   message: intl.formatMessage({
                                //     id: "percentage_range_message",
                                //   }),
                                // },
                                {
                                  validator: async (rule, value) => {
                                    const numericValue = parseFloat(value);
                                    if (
                                      isNaN(numericValue) ||
                                      numericValue > 100 ||
                                      numericValue < 0
                                    ) {
                                      return Promise.reject(
                                        intl.formatMessage({
                                          id: "percentage_range_message",
                                        })
                                      );
                                    }
                                    return Promise.resolve();
                                  },
                                },
                              ]}
                              initialValue={0}
                            >
                              <Input
                                placeholder={intl.formatMessage({
                                  id: "enter_percentage_placeholder",
                                })}
                                type="number"
                                max={100}
                                min={0}
                                suffix="%"
                              />
                            </Form.Item>
                          );
                        } else if (
                          selectedPriceType === PricingTypeEnum.CustomPrice
                        ) {
                          return (
                            <Form.Item
                              name="retail_price"
                              label={intl.formatMessage({
                                id: "retail_price_label",
                              })}
                              required={false}
                              rules={[
                                {
                                  required: true,
                                  message: intl.formatMessage({
                                    id: "price_required_message",
                                  }),
                                },
                                {
                                  type: "string",
                                  min: 0,
                                  message: intl.formatMessage({
                                    id: "positive_number_message",
                                  }),
                                },
                                {
                                  validator: async (rule, value) => {
                                    const numericValue = parseFloat(value);
                                    if (
                                      isNaN(numericValue) ||
                                      numericValue > non_discounted_price
                                    ) {
                                      return Promise.reject(
                                        intl.formatMessage({
                                          id: "price_validation_message",
                                        })
                                      );
                                    }
                                    return Promise.resolve();
                                  },
                                },
                              ]}
                            >
                              <Input
                                placeholder={intl.formatMessage({
                                  id: "enter_price_placeholder",
                                })}
                              />
                            </Form.Item>
                          );
                        } else {
                          return null;
                        }
                      }}
                    </Form.Item>
                  </div>
                  <div className="">
                    <Form.Item
                      label={intl.formatMessage({
                        id: "final_package_price_label",
                      })}
                      required={false}
                    >
                      <Input
                        disabled
                        value={retail_price}
                        style={{ backgroundColor: "#EEF0FF", border: "none" }}
                        className="text-sm"
                        suffix={intl.formatMessage({ id: "saudi_riyal" })}
                      />
                    </Form.Item>
                  </div>
                </div>
              </div>

              <div className="mt-5 flex justify-between flex-wrap gap-6">
                <div className="w-full md:w-[45%]">
                  <Form.Item
                    name={["general_description", "ar"]}
                    label={
                      <Flex>
                        <span className="mx-1">
                          {intl.formatMessage({
                            id: "package_description_label",
                          })}
                        </span>
                        {/* <small className="text-xs self-center mt-2">
                          ({intl.formatMessage({ id: "optional_label" })})
                        </small> */}
                      </Flex>
                    }
                    className="w-full"
                  >
                    <Input.TextArea
                      id="outlined-basic"
                      rows={2}
                      size="large"
                      placeholder={intl.formatMessage({
                        id: "enter_package_description_placeholder",
                      })}
                    />
                  </Form.Item>
                </div>
                <div className="w-full md:w-[45%]">
                  <Form.Item
                    name={["aftercare_description", "ar"]}
                    label={
                      <Flex>
                        <span className="mx-1">
                          {intl.formatMessage({
                            id: "aftercare_package_label",
                          })}
                        </span>
                        {/* <small className="text-xs self-center mt-2">
                          ({intl.formatMessage({ id: "optional_label" })})
                        </small> */}
                      </Flex>
                    }
                    className="w-full"
                  >
                    <Input.TextArea
                      id="outlined-basic"
                      rows={2}
                      size="large"
                      placeholder={intl.formatMessage({
                        id: "enter_aftercare_instructions_placeholder",
                      })}
                    />
                  </Form.Item>
                </div>
              </div>

              <Flex gap="small" align="center" justify="center">
                <Button
                  type="primary"
                  loading={isLoading || updateLoading}
                  block
                  htmlType="submit"
                >
                  {editPackageData
                    ? intl.formatMessage({ id: "update_package_button" })
                    : intl.formatMessage({ id: "add_package_button" })}
                </Button>
                <Button
                  type="primary"
                  disabled={isLoading}
                  className="btn-primary-light"
                  block
                  onClick={onClose}
                >
                  {intl.formatMessage({ id: "cancel_button" })}
                </Button>
              </Flex>
            </Form>
          </Card>
        </div>
      )}
    </Modal>
  );
};

export default AddAndEditPackageForm;
